import { useState, useMemo, useCallback,useEffect, useRef } from "react";
import axios from 'axios';
import config from '../config/config';
// ─── CONFIG ───────────────────────────────────────────────────────────────────
const MONTHLY_TRANSPORT = 450;          // Base monthly transport fee (ZAR / your currency)
const TERM_START_DATE   = new Date().getFullYear()+"-"+new Date().getMonth()+'-'+new Date().getDate(); // Term start
const TERM_END_DATE     = new Date().toISOString().split('T')[0]; // Term end

// ─── HELPERS ─────────────────────────────────────────────────────────────────
function monthsBetween(start, end) {
  const s = new Date(start);
  const e = new Date(end);
  return (e.getFullYear() - s.getFullYear()) * 12 + (e.getMonth() - s.getMonth()) + 1;
}

function getExpectedAmount(monthly, months) {
  return monthly * months;
}

function classifyDiscrepancy(charged, expected) {
  if (charged === expected) return "correct";
  if (charged === 0)        return "not_charged";
  if (charged < expected)   return "undercharged";
  if (charged > expected)   return "overcharged";
}

function discrepancyLabel(type) {
  return {
    correct:      { label: "Correct",       bg: "#f0fdf4", color: "#15803d", border: "#86efac", icon: "✓" },
    not_charged:  { label: "Not Charged",   bg: "#fff7ed", color: "#c2410c", border: "#fed7aa", icon: "⊘" },
    undercharged: { label: "Undercharged",  bg: "#fffbeb", color: "#b45309", border: "#fde68a", icon: "↓" },
    overcharged:  { label: "Overcharged",   bg: "#fef2f2", color: "#dc2626", border: "#fecaca", icon: "↑" },
  }[type] || {};
}

// ─── MOCK API DATA ────────────────────────────────────────────────────────────
const MOCK_STUDENTZ = [
  { id: "S001", name: "Emma Johnson",     class: "10A", transportAmount: 1800 },
  { id: "S002", name: "Liam Carter",      class: "8B",  transportAmount: 1350 },
  { id: "S003", name: "Sophia Lee",       class: "11C", transportAmount: 900  },
  { id: "S004", name: "Noah Williams",    class: "9A",  transportAmount: 1800 },
  { id: "S005", name: "Ava Thompson",     class: "12B", transportAmount: 0    },
  { id: "S006", name: "Oliver Martinez",  class: "7D",  transportAmount: 1800 },
  { id: "S007", name: "Isabella Brown",   class: "10A", transportAmount: 2250 },
  { id: "S008", name: "James Wilson",     class: "8C",  transportAmount: 1800 },
  { id: "S009", name: "Mia Davis",        class: "6A",  transportAmount: 450  },
  { id: "S010", name: "Ethan Garcia",     class: "11A", transportAmount: 1800 },
  { id: "S011", name: "Charlotte Lewis",  class: "9B",  transportAmount: 1350 },
  { id: "S012", name: "Lucas Walker",     class: "7A",  transportAmount: 1800 },
  { id: "S013", name: "Amelia Hall",      class: "12A", transportAmount: 600  },
  { id: "S014", name: "Benjamin Allen",   class: "8A",  transportAmount: 1800 },
  { id: "S015", name: "Harper Young",     class: "10B", transportAmount: 3600 },
  { id: "S016", name: "Elijah King",      class: "6B",  transportAmount: 1800 },
  { id: "S017", name: "Abigail Wright",   class: "11B", transportAmount: 0    },
  { id: "S018", name: "Mason Scott",      class: "9C",  transportAmount: 1800 },
  { id: "S019", name: "Ella Adams",       class: "7C",  transportAmount: 1350 },
  { id: "S020", name: "Logan Baker",      class: "12C", transportAmount: 1800 },
];

// ─── FAKE API CALL ────────────────────────────────────────────────────────────


// ─── BADGE ────────────────────────────────────────────────────────────────────
function Badge({ type }) {
  const s = discrepancyLabel(type);
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 20,
      background: s.bg, color: s.color, border: `1px solid ${s.border}`,
      letterSpacing: "0.2px", whiteSpace: "nowrap",
    }}>
      <span style={{ fontSize: 12 }}>{s.icon}</span>{s.label}
    </span>
  );
}

// ─── STAT CARD ────────────────────────────────────────────────────────────────
function StatCard({ label, value, sub, accent, icon }) {
  return (
    <div style={{
      background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14,
      padding: "18px 22px", flex: 1, minWidth: 150,
      borderTop: `3px solid ${accent}`, position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", right: 16, top: 16, fontSize: 22, opacity: 0.12 }}>{icon}</div>
      <div style={{ fontSize: 11, fontWeight: 700, color: "#9ca3af", letterSpacing: "0.6px", marginBottom: 6, textTransform: "uppercase" }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 800, color: "#111827" }}>{value}</div>
      {sub && <div style={{ fontSize: 12, color: "#6b7280", marginTop: 3, fontWeight: 500 }}>{sub}</div>}
    </div>
  );
}

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────
export default function TransportInconsistencies() {
    const detailRef = useRef(null);
  const [students, setStudents]       = useState([]);
  const [dashboardType,setDashboardType]=useState('Transport Fee');
  const [loading, setLoading]         = useState(false);
  const [votehead, setvotehead]         = useState('transport');
  const [term, setterm]         = useState('all');
  const[MOCK_STUDENTS,setMockStudents]=useState([]);
  const [loaded, setLoaded]           = useState(true);
  const [search, setSearch]           = useState("");
  const [filterClass, setFilterClass] = useState("all");
  const [filterFlag, setFilterFlag]   = useState("all");
  const [sortField, setSortField]     = useState("name");
  const [sortDir, setSortDir]         = useState("asc");
  const [selected, setSelected]       = useState(null);
  const [monthlyRate, setMonthlyRate] = useState(MONTHLY_TRANSPORT);
  const [termStart, setTermStart]     = useState(TERM_START_DATE);
  const [termEnd, setTermEnd]         = useState(TERM_END_DATE);
  const [showConfig, setShowConfig]   = useState(false);

  const termMonths = useMemo(() => monthsBetween(termStart, termEnd), [termStart, termEnd]);
  const expectedAmount = useMemo(() => getExpectedAmount(monthlyRate, termMonths), [monthlyRate, termMonths]);

  const cleanInconsistencies = async() =>{
    try {
      //setTxns([]);  
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrf = document.cookie.split('; ').find(r => r.startsWith('XSRF-TOKEN='))?.split('=')[1];

      const res = await axios.get(`${config.API_URL}/api/cleanInconsistencies`, {
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrf || ''),
        },
        withCredentials: true,
      });
window.location.reload();
      //setStudents(res.data.data);
      //setTermStart(res.data.startDate);
      //setTermEnd(res.data.endDate);
      // console.log(res.data.data);
      // setTotal(res.data.total); // Uncomment if you have a total state for pagination controls
    } catch (err) {
      console.error('Error fetching invoices:', err);
    }
  }

  const enriched = useMemo(() => students.map(s => {
    const type = classifyDiscrepancy(s.transportAmount, s.expected_amount);
    const diff  = s.transportAmount - s.expected_amount;
    const impliedMonths = monthlyRate > 0 ? (s.transportAmount / monthlyRate) : 0;
    return { ...s, type, diff, impliedMonths: Math.round(impliedMonths * 10) / 10 };
    expectedAmount=s.expected_amount;
  }), [students, expectedAmount, monthlyRate]);


  const classes = useMemo(() => ["all", ...new Set(students.map(s => s.class).sort())], [students]);

  const filtered = useMemo(() => {
    let rows = [...enriched];
    if (search)            rows = rows.filter(s => s.name.toLowerCase().includes(search.toLowerCase()) || s.id.toLowerCase().includes(search.toLowerCase()) || s.class.toLowerCase().includes(search.toLowerCase()));
    if (filterClass !== "all") rows = rows.filter(s => s.class === filterClass);
    if(filterFlag!=="resort"){
    if (filterFlag  !== "all") rows = rows.filter(s => s.type === filterFlag);
}
 if(filterFlag=="resort"){
  cleanInconsistencies();
 }
    rows.sort((a, b) => {
      let av = a[sortField];
      let bv = b[sortField];
      if (typeof av === "string") { av = av.toLowerCase(); bv = bv.toLowerCase(); }
      return sortDir === "asc" ? (av > bv ? 1 : -1) : (av < bv ? 1 : -1);
    });
    return rows;
  }, [enriched, search, filterClass, filterFlag, sortField, sortDir]);

  const stats = useMemo(() => ({
    total:        enriched.length,
    correct:      enriched.filter(s => s.type === "correct").length,
    overcharged:  enriched.filter(s => s.type === "overcharged").length,
    undercharged: enriched.filter(s => s.type === "undercharged").length,
    notCharged:   enriched.filter(s => s.type === "not_charged").length,
    totalOver:    enriched.filter(s => s.diff > 0).reduce((a, s) => a + s.diff, 0),
    totalUnder:   enriched.filter(s => s.diff < 0).reduce((a, s) => a + Math.abs(s.diff), 0),
  }), [enriched]);

  const load = useCallback(async () => {
    setLoading(true);
    const data = await fetchTransportData();
    setStudents(data);
    setLoaded(true);
    setLoading(false);
  }, []);

  const handleSort = (field) => {
    if (sortField === field) { setSortDir(d => d === "asc" ? "desc" : "asc"); }
    else { setSortField(field); setSortDir("asc"); }
  };

  const fmt = (n) => ` ${n?.toLocaleString("en-KE", { minimumFractionDigits: 2 })}`;

   const fetchStudents = async () => {
    try {
      //setTxns([]);  
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrf = document.cookie.split('; ').find(r => r.startsWith('XSRF-TOKEN='))?.split('=')[1];

      const res = await axios.get(`${config.API_URL}/api/pullvotestudents/${votehead}/${term}`, {
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrf || ''),
        },
        withCredentials: true,
      });

      setStudents(res.data.data);
      setTermStart(res.data.startDate);
      setTermEnd(res.data.endDate);
      // console.log(res.data.data);
      // setTotal(res.data.total); // Uncomment if you have a total state for pagination controls
    } catch (err) {
      console.error('Error fetching invoices:', err);
    }
  };

  

  useEffect(() => {
   
      fetchStudents();
  

  }, []);

  function fetchTransportData() {
  //  console.log(MOCK_STUDENTS);
 //return new Promise((res) => setTimeout(() => res(MOCK_STUDENTS), 1100));
}

  const SortIcon = ({ field }) => (
    <span style={{ marginLeft: 3, color: sortField === field ? "#2563eb" : "#d1d5db", fontSize: 11 }}>
      {sortField === field ? (sortDir === "asc" ? "▲" : "▼") : "⇅"}
    </span>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Quicksand', sans-serif", color: "#111827" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 5px; height: 5px; }
        ::-webkit-scrollbar-track { background: #f1f5f9; }
        ::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
        .row-h:hover { background: #f0f7ff !important; cursor: pointer; }
        .row-sel { background: #eff6ff !important; outline: 2px solid #bfdbfe; outline-offset: -2px; }
        .btn { font-family: 'Quicksand',sans-serif; font-weight: 700; cursor: pointer; border-radius: 8px; border: none; transition: all 0.15s; font-size: 13px; padding: 9px 18px; }
        .btn:hover { filter: brightness(0.93); transform: translateY(-1px); }
        .btn:disabled { opacity: 0.4; cursor: not-allowed; filter: none; transform: none; }
        .btn-primary { background: #2563eb; color: #fff; }
        .btn-ghost { background: #f3f4f6; color: #374151; border: 1px solid #e5e7eb; }
        .input-b { width: 100%; background: #fff; border: 1.5px solid #e5e7eb; border-radius: 8px; padding: 9px 13px; font-size: 13px; font-family: 'Quicksand',sans-serif; color: #111827; transition: border-color 0.15s, box-shadow 0.15s; outline: none; }
        .input-b:focus { border-color: #2563eb; box-shadow: 0 0 0 3px #eff6ff; }
        .th-b { background: none; border: none; cursor: pointer; font-family: 'Quicksand',sans-serif; font-weight: 700; font-size: 11px; color: #6b7280; letter-spacing: 0.5px; text-transform: uppercase; padding: 0; white-space: nowrap; }
        .th-b:hover { color: #2563eb; }
        .flag-chip { display:inline-flex; align-items:center; gap:6px; padding:6px 14px; border-radius:20px; border:1.5px solid; cursor:pointer; font-size:12px; font-weight:700; font-family:'Quicksand',sans-serif; transition:all 0.15s; white-space:nowrap; }
        .config-panel { background:#fff; border:1px solid #e5e7eb; border-radius:14px; padding:22px 26px; margin-bottom:22px; animation: slideDown 0.2s ease; }
        @keyframes slideDown { from { opacity:0; transform:translateY(-8px) } to { opacity:1; transform:translateY(0) } }
        .detail-row { display:flex; gap:8px; margin-bottom:9px; font-size:13px; }
        .dl { color:#9ca3af; min-width:130px; font-weight:700; }
        .dv { color:#374151; font-weight:600; }
        .pulse { animation: pulse 1.5s infinite; }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
      `}</style>



      <div style={{ maxWidth: 1300, margin: "0 auto", padding: "28px 32px" }}>

        {/* HEADER */}
       

        {/* CONFIG PANEL */}
        {showConfig && (
          <div className="config-panel">
            <div style={{ fontWeight: 800, fontSize: 14, marginBottom: 16, color: "#111827" }}>⚙ Term & Rate Configuration</div>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
              <div style={{ flex: 1, minWidth: 180 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6 }}>MONTHLY TRANSPORT RATE</label>
                <input className="input-b" type="number" value={monthlyRate} onChange={e => setMonthlyRate(Number(e.target.value))} placeholder="e.g. 450" />
              </div>
              <div style={{ flex: 1, minWidth: 160 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6 }}>TERM START DATE</label>
                <input className="input-b" type="date" value={termStart} onChange={e => setTermStart(e.target.value)} />
              </div>
              <div style={{ flex: 1, minWidth: 160 }}>
                <label style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", display: "block", marginBottom: 6 }}>TERM END DATE</label>
                <input className="input-b" type="date" value={termEnd} onChange={e => setTermEnd(e.target.value)} />
              </div>
              <div style={{ flex: 1, minWidth: 160, background: "#f0f7ff", borderRadius: 10, padding: "12px 16px", border: "1px solid #bfdbfe" }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: "#6b7280", marginBottom: 4 }}>CALCULATED EXPECTED</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "#2563eb" }}>{fmt(expectedAmount)}</div>
                <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>Ksh{monthlyRate} × {termMonths} months</div>
              </div>
            </div>
            
          </div>
        )}

        {/* STATS */}
        {loaded && (
          <div style={{ display: "flex", gap: 14, marginBottom: 24, flexWrap: "wrap" }}>
            <StatCard label="Total Students" value={stats.total}        sub="Loaded from API"                    accent="#6366f1" icon="👤" />
            <StatCard label="Correct"        value={stats.correct}      sub={`${((stats.correct/stats.total)*100).toFixed(0)}% of students`} accent="#16a34a" icon="✓" />
            <StatCard label="Overcharged"    value={stats.overcharged}  sub={`${fmt(stats.totalOver)} excess`}   accent="#dc2626" icon="↑" />
            <StatCard label="Undercharged"   value={stats.undercharged} sub={`${fmt(stats.totalUnder)} missing`} accent="#d97706" icon="↓" />
            <StatCard label="Not Charged"    value={stats.notCharged}   sub=" 0.00 recorded"                   accent="#c2410c" icon="⊘" />
          </div>
        )}

        {/* FLAG FILTER CHIPS */}
        {loaded && (
          <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
            {[
              { key: "all",         label: "All",          bg: "#f3f4f6", color: "#374151", border: "#e5e7eb" },
              { key: "correct",     label: "✓ Correct",    bg: "#f0fdf4", color: "#15803d", border: "#86efac" },
              { key: "overcharged", label: "↑ Overcharged",bg: "#fef2f2", color: "#dc2626", border: "#fecaca" },
              { key: "undercharged",label: "↓ Undercharged",bg:"#fffbeb", color: "#b45309", border: "#fde68a" },
              { key: "not_charged", label: "⊘ Not Charged",bg: "#fff7ed", color: "#c2410c", border: "#fed7aa" },
               { key: "resort", label: "✓ Clean Inconsistencies ",bg: "green", color: "#ffffff", border: "green" },
            ].map(chip => (
              <button
                key={chip.key}
                className="flag-chip"
                onClick={() => setFilterFlag(chip.key)}
                style={{
                  background: filterFlag === chip.key ? chip.color : chip.bg,
                  color: filterFlag === chip.key ? "#fff" : chip.color,
                  borderColor: chip.border,
                  boxShadow: filterFlag === chip.key ? `0 2px 8px ${chip.color}44` : "none",
                }}
              >
                {chip.label}
                <span style={{
                  background: filterFlag === chip.key ? "rgba(255,255,255,0.25)" : chip.border,
                  color: filterFlag === chip.key ? "#fff" : chip.color,
                  borderRadius: 20, padding: "1px 7px", fontSize: 11,
                }}>
                  {chip.key === "all" ? enriched.length : enriched.filter(s => s.type === chip.key).length}
                </span>
              </button>
            ))}
          </div>
        )}

        {/* SEARCH + CLASS FILTER */}
        {loaded && (
          <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap", alignItems: "center" }}>
            <div style={{ position: "relative", flex: 1, minWidth: 220 }}>
              <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}>🔍</span>
              <input className="input-b" style={{ paddingLeft: 34 }} value={search} onChange={e => setSearch(e.target.value)} placeholder="Search by name, ID or class…" />
            </div>
            <select className="input-b" style={{ width: "auto", minWidth: 150 }} value={filterClass} onChange={e => setFilterClass(e.target.value)}>
              {classes.map(c => <option key={c} value={c}>{c === "all" ? "All Classes" : `Class ${c}`}</option>)}
            </select>
            <div style={{ fontSize: 12, color: "#9ca3af", fontWeight: 600, whiteSpace: "nowrap" }}>
              {filtered.length} of {enriched.length} students
            </div>
            {(search || filterClass !== "all" || filterFlag !== "all") && (
              <button className="btn btn-ghost" style={{ padding: "8px 14px", fontSize: 12 }}
                onClick={() => { setSearch(""); setFilterClass("all"); setFilterFlag("all"); }}>
                ✕ Clear
              </button>
            )}
          </div>
        )}

        {/* EMPTY / NOT LOADED STATE */}
        {!loaded && !loading && (
          <div style={{ background: "#fff", border: "2px dashed #e5e7eb", borderRadius: 16, padding: "60px 40px", textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🚌</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#374151", marginBottom: 8 }}>No Data Loaded</div>
            <div style={{ fontSize: 13, color: "#9ca3af", marginBottom: 20, fontWeight: 500 }}>Click "Load Data" to fetch student transport records from the API and check for inconsistencies.</div>
            <button className="btn btn-primary" style={{ fontSize: 14, padding: "11px 28px" }} onClick={load}>⬇ Load Student Data</button>
          </div>
        )}

        {loading && (
          <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "60px 40px", textAlign: "center" }}>
            <div style={{ fontSize: 36, marginBottom: 12 }} className="pulse">⟳</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#374151" }}>Fetching transport data…</div>
          </div>
        )}

        {/* TABLE */}
        {loaded && !loading && (
          <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 14, overflow: "hidden" }}>
           {/* DETAIL PANEL */}
        {selected && (
          <div id="modals" ref={detailRef} style={{ background: "#fff", border: "1.5px solid #bfdbfe", borderRadius: 14, padding: 24, marginTop: 12, display: "flex", gap: 28, flexWrap: "wrap" }}>
            <div style={{ flex: 1, minWidth: 240 }}>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: "#9ca3af", marginBottom: 14 }}>STUDENT DETAIL</div>
              {[
                ["Student ID",       selected.id],
                ["Name",             selected.name],
                ["Class",            selected.class],
                ["Charged Amount",   fmt(selected.transportAmount)],
               
                ["Difference",       selected.diff === 0 ? "None" : `${selected.diff > 0 ? "+" : ""}${fmt(selected.diff)}`],
               
               
                ["Charge Months",   `${selected.months} months charged`],
              ].map(([k, v]) => (
                <div key={k} className="detail-row"><span className="dl">{k}</span><span className="dv">{v}</span></div>
              ))}
            </div>
            <div style={{ flex: 1, minWidth: 220 }}>
              <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: "#9ca3af", marginBottom: 14 }}>DIAGNOSIS</div>
              <div style={{ marginBottom: 14 }}><Badge type={selected.type} /></div>
              <div style={{ fontSize: 13, color: "#374151", fontWeight: 500, lineHeight: 1.7, background: "#f8fafc", borderRadius: 10, padding: "14px 16px", border: "1px solid #e5e7eb" }}>
                {selected.type === "correct"      && `Student is charged correctly. ${selected.months} months = ${fmt(selected.transportAmount)}.`}
                {selected.type === "overcharged"  && `Student is overcharged by ${fmt(selected.diff)}.`}
                {selected.type === "undercharged" && `Student is undercharged by ${fmt(Math.abs(selected.diff))}.`}
                {selected.type === "not_charged"  && `Student has not been charged for transport at all. Expected ${fmt(selected.expectedAmount)} for ${selected.months} months. An invoice should be raised immediately.`}
              </div>
             
            </div>
            <div>
              <button className="btn btn-ghost" onClick={() => setSelected(null)} style={{ fontSize: 12 }}>✕ Close</button>
            </div>
          </div>
        )}
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e5e7eb" }}>
                    {[
                      ["id",              "Student ID"],
                      ["name",            "Student Name"],
                      ["class",           "Class"],
                      ["expected_amount",   "Expected Amount"],
                      ["transportAmount", "Charged"],
                      ["diff",            "Difference"],
                       ["paidAmount",            "Paid Amount"],
                       ["balance",            "Balance"],
                        ["excess_amount",            "Excess Amount"],
                      ["impliedMonths",   "Charged Months"],
                    ].map(([f, label]) => (
                      <th key={f} style={{ padding: "12px 16px", textAlign: "left" }}>
                        <button className="th-b" onClick={() => handleSort(f)}>{label}<SortIcon field={f} /></button>
                      </th>
                    ))}
                    <th style={{ padding: "12px 16px", textAlign: "left" }}>
                      <span className="th-b">Status</span>
                    </th>
                    
                  </tr>
                </thead>
                <tbody>
                  {filtered.length === 0 && (
                    <tr><td colSpan={8} style={{ padding: 40, textAlign: "center", color: "#9ca3af", fontSize: 14 }}>No students match your filters.</td></tr>
                  )}
                  {filtered.map((s, i) => {
                    const isOdd = i % 2 === 0;
                    const diffColor = s.diff === 0 ? "#15803d" : s.diff > 0 ? "#dc2626" : "#b45309";
                    return (
                      <tr
                        key={s.id}
                        className={`row-h${selected?.id === s.id ? " row-sel" : ""}`}
                        onClick={() => {setSelected(selected?.id === s.id ? null : s); setTimeout(() => {
    detailRef.current?.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start'
    });
  }, 50);}}
                        style={{ background: isOdd ? "#fff" : "#fafafa", borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td style={{ padding: "12px 16px", fontSize: 12, color: "#6b7280", fontWeight: 600 }}>{s.id}</td>
                        <td style={{ padding: "12px 16px" }}>
                          <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{s.name}</div>
                        </td>
                        <td style={{ padding: "12px 16px" }}>
                          <span style={{ background: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe", borderRadius: 6, padding: "2px 9px", fontSize: 12, fontWeight: 700 }}>{s.class}</span>
                        </td>
                           <td style={{ padding: "12px 16px", fontSize: 13, color: "#6b7280", fontWeight: 600 }}>{fmt(s.expected_amount)}</td>
                        <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 700, color: "#111827" }}>{fmt(s.transportAmount)}</td>
                        <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 700, color: diffColor }}>
                          {s.diff === 0 ? "—" : `${s.diff > 0 ? "+" : ""}${fmt(s.diff)}`}
                        </td>
                         <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 700, color: "#111827" }}>{fmt(s.paidAmount)}</td>
                         <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 700, color: "#111827" }}>{fmt(s.transportAmount-s.paidAmount)}</td>
                        <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 700, color: "#111827" }}>{fmt(s.excess_amount)}</td>
                        <td style={{ padding: "12px 16px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                             <span style={{ fontSize: 12, fontWeight: 700, color: "#374151" }}>{s.months}</span>
                            <div style={{ flex: 1, height: 6, background: "#f1f5f9", borderRadius: 10, overflow: "hidden", maxWidth: 50 }}>
                              <div style={{
                                height: "100%", borderRadius: 10,
                                width: `${Math.min((s.months / termMonths) * 100, 100)}%`,
                                background: s.months === termMonths ? "#16a34a" : s.months > termMonths ? "#dc2626" : "#f59e0b",
                              }} />
                            </div>
                          
                          </div>
                        </td>
                        <td style={{ padding: "12px 16px" }}><Badge type={s.type} /></td>
                     
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr style={{ background: "#f8fafc", borderTop: "2px solid #e5e7eb" }}>
                    <td colSpan={3} style={{ padding: "12px 16px", fontSize: 12, fontWeight: 700, color: "#6b7280" }}>TOTALS ({filtered.length} students)</td>
                      <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 800, color: "#111827" }}>
                      {fmt(filtered.reduce((a, s) => a + parseFloat(s.expected_amount), 0))}
                    </td>
                    <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 800, color: "#111827" }}>
                      {fmt(filtered.reduce((a, s) => a + parseFloat(s.transportAmount), 0))}
                    </td>
                    <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 800, color: "#dc2626" }}>
                      {fmt(filtered.reduce((a, s) => a + parseFloat(s.diff), 0))}
                    </td>
                     <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 800, color: "#111827" }}>
                      {fmt(filtered.reduce((a, s) => a + parseFloat(s.paidAmount), 0))}
                    </td>
                     <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 800, color: "#111827" }}>
                      {fmt(filtered.reduce((a, s) => a + parseFloat(s.transportAmount)-parseFloat(s.paidAmount), 0))}
                    </td>
                     <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 800, color: "#111827" }}>
                      {fmt(filtered.reduce((a, s) => a + parseFloat(s.excess_amount), 0))}
                    </td>
                    <td colSpan={3} />
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        )}

       
      </div>
    </div>
  );
}